import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ListResultDTO } from 'src/app/helpers/listResult.interface';
import { environment } from 'src/environments/environment';
import { ProfessionalDTO, ProfessionalFilters } from '../../models/professional.model';

@Injectable({
  providedIn: "root"
})
export class LaravelProfessionalService {


  constructor(private httpClient: HttpClient) { }

  private get ROUTES() {
    return {

      list: environment.baseUrl + "/api/professionals",
      show: environment.baseUrl + "/api/professional",
      store: environment.baseUrl + "/api/professional",
      destroy: environment.baseUrl + "/api/professional",

    };
  }

  public list(page: number,
    per_page: number,
    order: string,
    direction: string,
    filters: ProfessionalFilters,
    includes?: string[]
  ): Observable<ListResultDTO<ProfessionalDTO>> {
    let params = {};
    if (order) params["order"] = "" + order;
    if (direction) params["direction"] = "" + direction;
    if (includes) params["includes[]"] = includes;
    if (filters) {
      if (filters.user_id) params["user_id"] = filters.user_id;
      if (filters.project_id) params["project_id"] = filters.project_id;
    }
    if (per_page) {
      params["per_page"] = "" + per_page;
      if (page) params["page"] = "" + page;
      return this.httpClient.get<ListResultDTO<ProfessionalDTO>>(this.ROUTES.list, {
        params: new HttpParams({ fromObject: params })
      });
    } else {
      return this.httpClient.get<ProfessionalDTO[]>(this.ROUTES.list, {
        params: new HttpParams({ fromObject: params })
      }).pipe(
        map(results => {
          return {
            data: results,
            total: results.length
          };
        })
      );
    }
  }


  public getProfessionalById(id: number): Observable<ProfessionalDTO> {
    let params = { id: "" + id };
    return this.httpClient.get<ProfessionalDTO>(this.ROUTES.show, {
      params: new HttpParams({
        fromObject: params
      })
    });

  }

  public upsert(professional: ProfessionalDTO): Observable<ProfessionalDTO> {
    if (professional.id) {
      return this.httpClient.put<ProfessionalDTO>(`${this.ROUTES.store}`, { professional });
    } else {
      return this.httpClient.post<ProfessionalDTO>(`${this.ROUTES.store}`, { professional });
    }
  }

  public delete(id: number): Observable<any> {
    let params = { id: "" + id };
    return this.httpClient.delete(this.ROUTES.destroy, {
      params: new HttpParams({
        fromObject: params
      })
    });
  }
}
